export const ListSearchFilterTypes = {
  //Note: these are also mapped to backend ids please change with care
  SingleSelect: "single_select",
  SingleRadio: "single_select_radio",
  MultiSelect: "multi_select",
  MultiCheckbox: "multi_select_check",
  Text: "text",
  Number: "number",
  NumberRange: "number_range",
  Custom: "custom"
};